// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"RemoveMediaButton__removeButton__9-his","removeIcon":"RemoveMediaButton__removeIcon__qGzMI"};